var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div1",staticClass:"_div",style:({backgroundImage: 'url(' +_vm.imgUrl+ ')'}),on:{"click":_vm.handleBodyClick}})}
var staticRenderFns = []

export { render, staticRenderFns }